import styled from "styled-components"

const FooterStyle = styled.footer`
  p {
    font-size: ${({ theme }) => theme.fontSizes.xs};
    margin: 0;
    text-align: center;
  }
`
export default FooterStyle
